export interface Connection {
  id: string
  name: string
  provider: string
  providerConfig?: ProviderConfig
  status: string
  createdAt: string
  updatedAt: string
  lastConnectedAt?: string
  lastImportedAt?: string
  ownerId?: string
  myPermissions?: Set<string>
}

export interface ConnectionProfile {
  id: string
  name: string
  provider: string
  status: string
}

export const enum ConnectionStatus {
  NotConnected = "NOT_CONNECTED",
  ScopesInitializing = "SCOPES_INITIALIZING",
  NotImported = "NOT_IMPORTED",
  InProgress = "IN_PROGRESS",
  ImportFailed = "IMPORT_FAILED",
  ImportDone = "IMPORT_DONE",
  Connected = "CONNECTED",
}

export interface ProviderConfig {
  domain?: string
  workspaceId?: string
}
